import { RESET_BEHAVE_AS, SET_BEHAVE_AS } from "./appConstants";

const initialState = {
  behaveAs: "",
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BEHAVE_AS:
      return {
        ...state,
        behaveAs: action.email,
      };

    case RESET_BEHAVE_AS:
      return {
        ...state,
        behaveAs: "",
      };
    default:
      return state;
  }
};

export default reducer;
